// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__10tS-","subheader":"ReorderModal_subheader__MHREE","listWrap":"ReorderModal_listWrap__1JScm"};